import { render, staticRenderFns } from "./SituationCard.vue?vue&type=template&id=1cb1dc9e&scoped=true&"
import script from "./SituationCard.vue?vue&type=script&lang=js&"
export * from "./SituationCard.vue?vue&type=script&lang=js&"
import style0 from "./SituationCard.vue?vue&type=style&index=0&id=1cb1dc9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb1dc9e",
  null
  
)

export default component.exports